function setQueryStringParameter(name, value) {
    const params = new URLSearchParams(window.location.search);
    params.set(name, value);
    window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
}

function deleteQueryStringParameter(name) {
    const params = new URLSearchParams(window.location.search);
    var keys = 0;
    for (const key of params.keys()) {
        keys++;
    }
    params.delete(name);
    if (keys === 1) {
        window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}`));
    } else {
        window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
    }
}

function clearQueryStringParameter() {
    const params = new URLSearchParams(window.location.search);
    if(params.has('sort')) {
        const sortParams = new URLSearchParams();
        sortParams.set('sort',params.get('sort'));
        window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${sortParams}`));
    } else {
        window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}`));
    }
}
jQuery.noConflict();
(function($) {
$( document ).ready(function() {
// andherewego.exe
    $('#market_slider > .vc_custom_1622664375759 > .wpb_wrapper').slick({
        slide: '.market_slide',
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><img src="/wp-content/themes/dt-the7-child/assets/img/LeftArrow.svg" /></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><img src="/wp-content/themes/dt-the7-child/assets/img/RightArrow.svg" /></button>',
    });
    $('.scrollToSource').on('click', function(e) {
        var href = $(this).attr('href');
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
        $([document.documentElement, document.body]).animate({
            scrollTop: $(href).offset().top - 120
        }, 500);
    });
    $('.load_more').on('click', function(e) {
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
        $(this).siblings('.hide').slice(0,10).removeClass('hide');
        if ($(this).siblings('.hide').length === 0) {
            $(this).addClass('hide');
            $(this).siblings('.viewall').removeClass('hide');
        }
        $(this).closest('.search_source').find('.number').text($(this).siblings('.result').not('.hide').length);
    });

    if ($('body').hasClass('single-project')) {
        // $('h3').each(function(index, item) {
        //     if (item.innerHTML == 'Industry Type') {
        //         console.log('Industry Type');
        //         var industryType = $(item).next('p');
        //         industryType = industryType[0].innerText;
        //         console.log(industryType);
        //     }
        // });
        var market = $('#projectMarkets');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'projectMarket',
            'action': 'Page Load',
            'market': market[0].innerText,
        });
        console.log(market[0].innerText);
    }
// end it all
});
$(document).on('facetwp-loaded', function() {
    if (FWP.loaded) {
        gtag('config', 'UA-55077740-1', {'page_path': window.location.pathname + window.location.search});
    }
    var facets = window.location.search;
    if (facets !== '') {
        $('#allprojects').addClass('hide');
    } else {
        $('#allprojects').removeClass('hide');
    }
});
$(document).on('facetwp-refresh', function() {
    $('#allprojects').removeClass('hide');
});

// Views by client type
$('#wpv-wpcf-client-type').on('change', function(e) {
    $("form[name='client_type']").submit();
    deleteQueryStringParameter('paged');
    setQueryStringParameter('wpv-wpcf-client-type', encodeURIComponent($(this).val()));
})

$("form[name='client_type']").on('submit', function(e) {
    e.preventDefault();

    var $form = $(this);
    var dataPacket = {};
    $.each($form.serializeArray(), function( key, item) {
        dataPacket[item.name] = item.value;
    });
    $.post($form.attr('action'), dataPacket, function(data) {
        $('#ajax-results').html(data);
    })
    .done(function() {
        const params = new URLSearchParams(window.location.search);
        $('.pagination li a').each(function(index) { 
            let href = $(this).attr('href');
            if (params.size > 0) {
                href = href + '&' + params.toString();
            }
            $(this).attr('href', href); 
        });
        console.log('done');
    })
    .fail(function() {
        console.log('There was an error');
    });
});

// Views by market
$('#wpv-wpcf-by-market').on('change', function(e) {
    $("form[name='by_market']").submit();
    deleteQueryStringParameter('paged');
    setQueryStringParameter('wpv-wpcf-by-market', encodeURIComponent($(this).val()));
})

$("form[name='by_market']").on('submit', function(e) {
    e.preventDefault();

    var $form = $(this);
    var dataPacket = {};
    $.each($form.serializeArray(), function( key, item) {
        dataPacket[item.name] = item.value;
    });
    $.post($form.attr('action'), dataPacket, function(data) {
        $('#ajax-results').html(data);
    })
    .done(function() {
        const params = new URLSearchParams(window.location.search);
        $('.pagination li a').each(function(index) { 
            let href = $(this).attr('href');
            if (params.size > 0) {
                href = href + '&' + params.toString();
            }
            $(this).attr('href', href); 
        });
        console.log('done');
    })
    .fail(function() {
        console.log('There was an error');
    });
});

// Views by service
$('#wpv-wpcf-work-scope').on('change', function(e) {
    $("form[name='work_scope']").submit();
    deleteQueryStringParameter('paged');
    setQueryStringParameter('wpv-wpcf-work-scope', encodeURIComponent($(this).val()));
})

$("form[name='work_scope']").on('submit', function(e) {
    e.preventDefault();

    var $form = $(this);
    var dataPacket = {};
    $.each($form.serializeArray(), function( key, item) {
        dataPacket[item.name] = item.value;
    });
    $.post($form.attr('action'), dataPacket, function(data) {
        $('#ajax-results').html(data);
    })
    .done(function() {
        const params = new URLSearchParams(window.location.search);
        $('.pagination li a').each(function(index) { 
            let href = $(this).attr('href');
            if (params.size > 0) {
                href = href + '&' + params.toString();
            }
            $(this).attr('href', href); 
        });
        console.log('done');
    })
    .fail(function() {
        console.log('There was an error');
    });
});

// News page filters
$('.filter-btn').on('click', function(e) {
    e.preventDefault();
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    if ($(this).data('term') == '') {
        deleteQueryStringParameter('term');
        deleteQueryStringParameter('paged');
        $("form[name='news_filters'] input[name='term']").val('');
    } else {
        deleteQueryStringParameter('paged');
        $("form[name='news_filters'] input[name='term']").val($(this).data('term'));
        setQueryStringParameter('term', encodeURIComponent($(this).data('term')));
    }
    $("form[name='news_filters']").submit();
});
$('.filter-by a').on('click', function(e) {
    e.preventDefault();
    deleteQueryStringParameter('paged');
    $("form[name='news_filters'] input[name='orderby']").val($(this).data('orderby'));
    setQueryStringParameter('orderby', encodeURIComponent($(this).data('orderby')));
    $("form[name='news_filters']").submit();
});
$('.filter-sorting a').on('click', function(e) {
    e.preventDefault();
    deleteQueryStringParameter('paged');
    $("form[name='news_filters'] input[name='order']").val($(this).data('sort'));
    setQueryStringParameter('order', encodeURIComponent($(this).data('sort')));
    $("form[name='news_filters']").submit();
});

$("form[name='news_filters']").on('submit', function(e) {
    e.preventDefault();

    var $form = $(this);
    var dataPacket = {};
    var form_params = {};
    const param_keys = ['order','orderby','term'];
    $.each($form.serializeArray(), function( key, item) {
        dataPacket[item.name] = item.value;
        if (param_keys.includes(item.name)) {
            form_params[item.name] = item.value;
        }
    });
    $.post($form.attr('action'), dataPacket, function(data) {
        $('#news_container_wrapper').html(data);
    })
    .done(function() {
        const params = new URLSearchParams(window.location.search);
        console.log(form_params);
        $.each(form_params, function(key, value) {
            if (value != '') {
                params.set(key, value);
            } else {
                params.delete(key);
            }
        });
        $('.pagination li a').each(function(index) { 
            let href = $(this).attr('href');
            if (params.size > 0) {
                href = href + '&' + params.toString();
            }
            $(this).attr('href', href); 
        });
        window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
        console.log('done');
    })
    .fail(function() {
        console.log('There was an error');
    });
});

$(window).on('scroll', function() {
    if ($(this).scrollTop() > 175) {
        $('#phantom').fadeIn();
    } else {
        $('#phantom').fadeOut();
    }
    if ($(this).scrollTop() > 39.59) {
        $('#top-bar-menu').addClass('stuck');
        $('#top-bar-spacer').addClass('stuck');
    } else {
        $('#top-bar-menu').removeClass('stuck');
        $('#top-bar-spacer').removeClass('stuck');
    }
});

$('#off-canvas-close span').on('click', function(e) {
    console.log('Hiyo');
    $('#off-canvas').foundation('close');
});

})(jQuery);